<template>
  <div>
    <!-- This component doesn't need visual elements as it handles logout logic -->
  </div>
</template>

<script>
import { useUserStore } from '../stores/Global.js';
import axios from 'axios';
import { BACKEND_URL } from '../../../share-source/src/config/config.js';

export default {
  name: 'BackendLogout',
  setup() {
    const userStore = useUserStore();
    return {
      userStore
    }
  },
  created() {
    // Clear any auth tokens or session data
    // localStorage.removeItem('token')
    // sessionStorage.clear()
    // console.log("logging out");
    axios.get(`${BACKEND_URL}/logout`).then(() => {  
      // console.log("logged out");
      this.userStore.logout();
      this.userStore.setStudentId(0);
      window.close();
      // this.$router.push('/backend-login');
    });
  }
}
</script>